import i18n from 'modules/core/lib/i18n'

export const settingsRefreshBannerTranslations = (
  client_data_last_updated_at: string | undefined = undefined
) => {
  return {
    refresh_banner_title: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.business_unit.refresh_banner.title'
    ),
    refresh_banner_description: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.business_unit.refresh_banner.description',
      { client_data_last_updated_at: client_data_last_updated_at }
    ),
    refresh_banner_button_text: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.business_unit.refresh_banner.button_text'
    ),
    error_banner_title: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.business_unit.error_banner.title'
    ),
    error_banner_description: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.business_unit.error_banner.description'
    ),
    error_banner_button_text: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.business_unit.error_banner.button_text'
    ),
    retrieving_data_banner_title: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.business_unit.retrieving_data_banner.title'
    ),
    retrieving_data_banner_description: i18n.t(
      'app_store_v2.app_integrations.payroll_integrations_datev_lauds.settings.steps.business_unit.retrieving_data_banner.description'
    ),
  }
}
